import styled from 'styled-components';
const StyledPaymentContainer = styled.div``;
export default StyledPaymentContainer;
